import axios from "axios"
import { getTokenFromLocalStorage } from "../helpers/helpers"
import {API_URL} from '../constants/constants'

axios.defaults.headers.common = {
  Authorization: `Bearer ${getTokenFromLocalStorage()}`,
}

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*"
const axiosApi = axios.create({
  baseURL: API_URL,
})
axiosApi.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    return config;
});

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config })
}

export async function post(url, data, config = {}) {
  return axiosApi.post(url, { ...data }, { ...config })
}

export async function put(url, data) {
  return axiosApi.post(`${url}/roles/${data.id}/update`, data)
}

export async function del(url) {
  return await axiosApi.delete(url)
}
